import { render } from "./PublicAgahiItem.vue?vue&type=template&id=ab22a0e0&scoped=true"
import script from "./PublicAgahiItem.vue?vue&type=script&lang=js"
export * from "./PublicAgahiItem.vue?vue&type=script&lang=js"

import "./PublicAgahiItem.vue?vue&type=style&index=0&id=ab22a0e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab22a0e0"]])

export default __exports__